module.exports = __webpack_public_path__ + "static/img/chenlin.d3eba358.jpg";